import { Taxes } from 'features/sport/components/sportTicket/sportTicketSlice';
import dynamic from 'next/dynamic';

export * from './constant';

export type CarrelloProps = {
  taxes?: Taxes;
};

export const Carrello = dynamic<CarrelloProps>(() => import('features/carrello/Carrello').then((mod) => mod.Carrello), {
  ssr: false,
});
